import { useI18n } from "@/context/I18nContext";
import { Languages } from "lucide-react";

export default function LanguageToggle() {
  const { lang, setLang } = useI18n();
  return (
    <div
      className="inline-flex items-center gap-1 rounded-full bg-zinc-900/70 border border-white/10 p-1"
      data-testid="language-toggle"
    >
      <Languages className="w-4 h-4 text-zinc-400 ml-2" />
      <button
        type="button"
        data-testid="lang-fr-btn"
        onClick={() => setLang("fr")}
        className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${lang === "fr" ? "bg-[#FF0050] text-white" : "text-zinc-400 hover:text-white"}`}
      >FR</button>
      <button
        type="button"
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${lang === "en" ? "bg-[#FF0050] text-white" : "text-zinc-400 hover:text-white"}`}
      >EN</button>
    </div>
  );
}
